import { render, staticRenderFns } from "./filterstrain.vue?vue&type=template&id=12c4d0ca&scoped=true"
import script from "./filterstrain.vue?vue&type=script&lang=js"
export * from "./filterstrain.vue?vue&type=script&lang=js"
import style0 from "./filterstrain.vue?vue&type=style&index=0&id=12c4d0ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4d0ca",
  null
  
)

export default component.exports